import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import { useBoundStore } from "../../store";

export function MsaBanner() {
    const navigate = useNavigate();
    const user = useBoundStore((state) => state.user);
    const updateUserInfo = useBoundStore((state) => state.updateUserInfo);

    // Refresh user data on mount so msaAgreementSigned is up to date
    // (localStorage may have stale data from login time)
    useEffect(() => {
        if (user?.usertype === "verified creator" && !user?.msaAgreementSigned) {
            // Best-effort refresh: the banner keeps rendering from the cached
            // user if the request fails (a 401 is already handled by the axios
            // interceptor), so the rejection must not escape as an unhandled one.
            updateUserInfo().catch(() => {});
        }
    }, []);

    if (!user) return null;
    if (user.usertype !== "verified creator") return null;
    if (user.msaAgreementSigned) return null;

    return (
        <Alert
            severity="warning"
            sx={{
                borderRadius: 0,
                display: "flex",
                alignItems: "center",
                "& .MuiAlert-message": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%"
                }
            }}
        >
            Your Master Service Agreement requires your signature.
            <Button size="small" variant="contained" color="primary" /* /profile is the expert router's page and is not brand-scoped, so it
               takes no portal prefix (TDC-1609). */
            onClick={() => navigate(`/profile?tab=MSA&t=${Date.now()}`)}>
                Sign MSA
            </Button>
        </Alert>
    );
}
